import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PaymentTransactionsContent } from './PaymentTransactionsContent';

export default function PaymentTransactionsPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <PaymentTransactionsContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
